import axios from 'axios';
import { BACKEND_URL } from './config';
import {
  normalizeHappeningNowResponse,
  sanitizeSections,
} from '../utils/happeningNowFeed';

/** Dev sample — two Twitch scopes + local TV when API is empty. */
const SAMPLE_SECTIONS = sanitizeSections([
  {
    id: 'twitch-global',
    scope: 'global',
    label: 'Worldwide',
    platform: 'twitch',
    items: [
      { live: true, name: 'IEM Cologne Major — Quarter-final', channel: 'ESL CS', meta: '111K watching', platform: 'twitch', source: 'twitch', scope: 'global', url: 'https://www.twitch.tv/eslcs' },
      { live: true, name: 'UFC 320 Prelims', channel: 'UFC', meta: '97K watching', platform: 'twitch', source: 'twitch', scope: 'global', url: 'https://www.twitch.tv/ufc' },
      { live: true, name: 'GTA VI deep dive & reacts', channel: 'Rubius', meta: '28K watching', platform: 'twitch', source: 'twitch', scope: 'global', url: 'https://www.twitch.tv/rubius' },
    ],
  },
  {
    id: 'kick-global',
    scope: 'global',
    label: 'Worldwide',
    platform: 'kick',
    items: [
      { live: true, name: 'chill stream', channel: 'Cavs', meta: '2.8K watching', platform: 'kick', source: 'kick', scope: 'global', url: 'https://kick.com/cavs' },
      { live: true, name: 'VALORANT ranked', channel: 'gothamready', meta: '943 watching', platform: 'kick', source: 'kick', scope: 'global', url: 'https://kick.com/gothamready' },
    ],
  },
  {
    id: 'twitch-pt',
    scope: 'country',
    countryCode: 'PT',
    label: 'Portugal',
    platform: 'twitch',
    items: [
      { live: true, name: 'Liga Portugal — Benfica vs Porto watch party', channel: 'SportTV_PT', meta: '4.2K watching', platform: 'twitch', source: 'twitch', scope: 'country', countryCode: 'PT', url: 'https://www.twitch.tv/demo_pt' },
      { live: true, name: 'F1 Portugal community stream', channel: 'F1PT', meta: '1.8K watching', platform: 'twitch', source: 'twitch', scope: 'country', countryCode: 'PT', url: 'https://www.twitch.tv/demo_f1pt' },
    ],
  },
  {
    id: 'local-pt',
    scope: 'country',
    countryCode: 'PT',
    label: 'Portugal · TV & more',
    items: [
      { live: true, name: 'Porto vs Benfica', channel: 'Sport TV 1', meta: '128K watching', platform: 'epg', source: 'epg', countryCode: 'PT', logo: 'https://i.imgur.com/YWic36u.png' },
      { live: true, name: 'F1 Abu Dhabi GP — FP2', channel: 'F1', meta: '301K watching', platform: 'youtube', source: 'youtube', countryCode: 'PT', url: 'https://youtube.com/watch?v=demo' },
      { live: false, name: 'Porto vs Sporting', channel: 'Sport TV 1', meta: 'tomorrow 20:15', platform: 'epg', source: 'epg', countryCode: 'PT', logo: 'https://i.imgur.com/YWic36u.png' },
    ],
  },
]);

/**
 * Discovery feed for DynamicFooterTicker.
 * Returns scoped sections (Worldwide / country Twitch, plus local slices).
 *
 * Backend contract (preferred):
 *   { sections: [{ id, scope, label, countryCode?, platform?, items }] }
 *
 * Also accepts:
 *   { twitch: { global: { items }, country: { countryCode, items } }, kick: { ... }, items }
 *   { items: [...] } with optional item.scope / item.countryCode
 */
export async function getHappeningNow() {
  try {
    const { data } = await axios.get(`${BACKEND_URL}/api/discovery/happening-now`, {
      timeout: 15000,
    });
    const sections = normalizeHappeningNowResponse(data);
    if (sections.length > 0) {
      return sections;
    }
    if (import.meta.env.DEV) {
      return SAMPLE_SECTIONS;
    }
    return [];
  } catch (error) {
    console.warn('[happeningNow] API fetch failed:', error.message);
    if (import.meta.env.DEV) {
      return SAMPLE_SECTIONS;
    }
    return [];
  }
}
